import * as React from 'react';
import { style } from './style';
export const Badge = (props) => {
    const count = props.maxCount && props.maxCount < props.count ? `${props.maxCount}+` : props.count;
    const css = style(props);
    return (React.createElement("div", { className: css.container },
        React.createElement("sup", { className: css.count }, count),
        props.children));
};
Badge.defaultProps = {
    color: 'red',
};
//# sourceMappingURL=Badge.js.map